export const SNACKBAR = "SNACKBAR";
